import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <rect width="16" height="20" x="4" y="2" rx="2" ry="2"/>
  <path d="M9 22v-4h6v4"/>
  <path d="M8 6h.01"/>
  <path d="M16 6h.01"/>
  <path d="M12 6h.01"/>
  <path d="M12 10h.01"/>
  <path d="M12 14h.01"/>
  <path d="M16 10h.01"/>
  <path d="M16 14h.01"/>
  <path d="M8 10h.01"/>
  <path d="M8 14h.01"/>
</svg>`;

const Organization = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='organization' svg={svg} {...props} />
  )
);

Organization.displayName = 'OrganizationIcon';

export default Organization;
